import './App.scss';
import { Header } from './components/Header';
import MenuOverlay from './components/MenuOerlay';
import HeroSection from './components/HeroSection';
import InformationSection from './components/InformationSection';
import ImagesCollection from './components/ImagesCollection';
import AboutSection from './components/AboutSection';
import ContactForm from './components/ContactForm';
import FooterMenu from './components/FooterMenu';
import { Container, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import fallbackImage from './assets/images/IMG_0120.jpeg';

function App() {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <div className='App'>
      <Container fluid>
        <Header navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
        <MenuOverlay navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} />
        <HeroSection />
        <InformationSection />
        <ImagesCollection />
        <AboutSection />

        <Container className='footer-section'>
          <Row>
            <div className='contact-us-img'>
              <img src={fallbackImage} alt='hand holding camera' />
            </div>
          </Row>
          <Row className='my-3'>
            <Col xs={12} md={6}>
              <ContactForm />
            </Col>
            <Col xs={12} md={6}>
              <FooterMenu />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default App;
